import * as React from 'react';

const PaymentsTableHead = () => {
  return(
    <div className='payment-table-head d-flex'>
      <div>{'Date'}</div>
      <div>{'Time'}</div>
      <div>{'Type'}</div>
      <div>{'Payment system'}</div>
      <div>{'Sum'}</div>
    </div>
  );
};

export default PaymentsTableHead;
